import {
  Avatar,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { BsPeople } from "react-icons/bs";
import { RiSearch2Line } from "react-icons/ri";
import {
  IAssessmentTheoryAnswersData,
  IAssessmentTheoryAnswersQuestion,
  UserQuestionAnswer,
} from "../../../../models/assignments/theoryAnswersAssessment.model";
import {
  IUserProfile,
  IUserProfileRes,
} from "../../../../models/userprofile.model";
import trainerAssignmentService from "../../../../services/trainer/trainer-assignment.service";
import userService from "../../../../services/user.service";
import Loading from "../../../common/Loading";

export default function TrTheoryAnswers() {
  const navigate = useNavigate();
  const toast = useToast();
  const { assignment_id, course_id } = useParams();
  const [assessmentAnswer, setAssessmentAnswer] =
    useState<IAssessmentTheoryAnswersData>();
  const [loading, setLoading] = useState(true);
  const [selectedUserAnswer, setSelectedUserAnswer] = useState<
    UserQuestionAnswer[]
  >([{ score: 0, user_question_answer_id: "" }]);
  const [questions, setQuestions] =
    useState<IAssessmentTheoryAnswersQuestion[]>();
  const [groupedUsers, setGroupedUsers] = useState<any>();
  const [users, setUsers] = useState<IUserProfile[]>();
  const [isScoreReport, setIsScoreReport] = useState(true);
  const [scoreReport, setScoreReport] = useState<any[]>();
  const [isEmpty, setIsEmpty] = useState(false);
  const [passMark, setPassMark] = useState<number>();

  function calculatePercentage(numerator: number, denominator: number) {
    if (denominator === 0) {
      return "Denominator cannot be zero";
    }

    const percentage = (numerator / denominator) * 100;
    return percentage.toFixed(2) + "%";
  }

  const handleChangeScore = (
    index: number,
    field: keyof UserQuestionAnswer,
    value: string,
    field2: keyof UserQuestionAnswer,
    id: number | undefined
  ) => {
    setSelectedUserAnswer((prevScore) => {
      const updatedScore = [...prevScore];
      updatedScore[index][field] = value;
      updatedScore[index][field2] = id;
      return updatedScore;
    });
  };

  useEffect(() => {
    trainerAssignmentService
      .getAssessmentAnswers(assignment_id)
      .then(async (res) => {
        const assesData: IAssessmentTheoryAnswersData = res.data;
        setQuestions(assesData.questions);
        if (assesData.header.user_question_answer.length === 0) {
          // set to empty if no trainee has answered the quiz
          setIsEmpty(true);
        }
        setPassMark(assesData?.header.pass_mark);
        // Initialize an empty object to store grouped data
        const groupedData: any = {};
        const userArray: IUserProfile[] = [];
        // Iterate through the array and group objects by their ID
        assesData.header.user_question_answer.forEach((item) => {
          const id = item.user_id && item.user_id.toString();
          // If the ID is not in groupedData, create an empty array
          if (id) {
            if (!groupedData[id]) {
              groupedData[id] = [];
            }
            // Push the object into the corresponding group
            groupedData[id].push(item);
          }
        });
        console.log(groupedData[2], "hereeeee");
        const userIdArray: string[] = Object.keys(groupedData);
        for (let index = 0; index < userIdArray.length; index++) {
          const element = userIdArray[index];
          const user: IUserProfileRes = await userService.getUserProfile(
            element
          );
          if (user) {
            userArray.push(user.data);
          }
        }

        setUsers([...userArray]);
        setGroupedUsers(groupedData);

        //trying to get score report data
        const userScoreArray = [];
        //loop through the groupedData object
        for (const key in groupedData) {
          if (groupedData.hasOwnProperty(key)) {
            const id = key;
            //get scores for a particular user
            const scores = groupedData[key];
            //add it up to get the total score of the user

            const scoreSum = scores.reduce(
              (total: number, item: { score: string }) => {
                const scoreValue = parseInt(item.score); // Convert score to an integer
                if (!isNaN(scoreValue)) {
                  return total + scoreValue;
                }
                return total;
              },
              0
            );
            const totalScore = scores.reduce(
              (total: number, item: { total_mark: string }) => {
                const scoreValue = parseInt(item.total_mark); // Convert score to an integer
                if (!isNaN(scoreValue)) {
                  return total + scoreValue;
                }
                return total;
              },
              0
            );
            //total_mark
            const percent = calculatePercentage(scoreSum, totalScore);
            userScoreArray.push({
              id,
              score: scoreSum,
              total_score: totalScore,
              percent: percent,
            });
          }
          setScoreReport(userScoreArray);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function getSelectedUser(id: string) {
    setSelectedUserAnswer(groupedUsers[id]);
    setIsScoreReport(false);
  }

  useEffect(() => {
    console.log(selectedUserAnswer, "user anser");
  }, [selectedUserAnswer]);

  const submitAnswer = async () => {
    try {
      const submitArray = selectedUserAnswer.map(
        ({
          id: user_question_answer_id,
          question_id,
          score,
        }: UserQuestionAnswer) => {
          return {
            user_question_answer_id,
            question_id,
            score,
          };
        }
      );

      const submitAnswerApi = await trainerAssignmentService.markTheoryAnswers(
        {
          assessments: [...submitArray],
        },
        course_id,
        assignment_id
      );
      if (submitAnswerApi.success) {
        toast({
          title: "Mark Assessment",
          description: `${submitAnswerApi.message}`,
          status: "success",
        });
      } else {
        toast({
          title: "Mark Assessment",
          description: `${submitAnswerApi.message}`,
          status: "error",
        });
      }
    } catch (error) {
      toast({
        title: "Mark Assessment",
        description: `something went wrong`,
        status: "error",
      });
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex minHeight="100vh" width="100%" bg="white">
          <Box
            width="25%"
            borderRight="1px solid"
            pt="15px"
            pl="15px"
            borderColor="lightgray"
          >
            <HStack
              cursor={"pointer"}
              onClick={() => {
                setIsScoreReport(true);
              }}
              spacing="5px"
              pl="15px"
              py="10px"
              bg="#FF961B0A"
            >
              <Center
                width="32px"
                bg="#FFE1E2"
                height="32px"
                borderRadius="16px"
              >
                <BsPeople />
              </Center>
              <Text>Score Report</Text>
            </HStack>
            <Box mt="10px" mb="10px">
              <InputGroup
                variant="flushed"
                height="45px"
                color="#616161"
                bg="white"
                mr="20px"
                width="100%"
              >
                <Input placeholder="Search trainees" fontSize={12} size="sm" />

                <InputRightElement
                  h="1.9rem"
                  pointerEvents="none"
                  children={<RiSearch2Line color="red" size="0.9rem" />}
                />
              </InputGroup>
            </Box>
            {users &&
              users.map((user, index) => (
                <Tooltip
                  label={`Click to score ${user.name}`}
                  aria-label="Trainee Info"
                >
                  <HStack
                    onClick={() => {
                      getSelectedUser(user.id.toString());
                    }}
                    spacing={2}
                    cursor={"pointer"}
                    key={index}
                    pl="15px"
                    mb="10px"
                    borderBottom="1px solid"
                    borderColor="lightgray"
                    pb="10px"
                  >
                    <Avatar size={"sm"} name={user.name} />
                    <Text fontSize="14px" color="#616161">
                      {user.name}
                    </Text>
                  </HStack>
                </Tooltip>
              ))}
          </Box>
          <Box width="70%" pt="20px" pl="30px" pr="30px">
            {isScoreReport && (
              <Box>
                <TableContainer>
                  <Table size={"sm"} variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Trainee Name</Th>
                        <Th textTransform="none">Total Score</Th>
                        <Th textTransform="none">Total Obtainable Score</Th>
                        <Th textTransform="none">Total(%)</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {scoreReport &&
                        scoreReport.map((each, index) => (
                          <Tr bg="white" key={index}>
                            <Td>
                              <HStack spacing="10px">
                                <Avatar
                                  name={users && users[index].name}
                                  size="sm"
                                />
                                <Text
                                  fontWeight="500"
                                  fontSize="13px"
                                  color="#616161"
                                >
                                  {users && users[index].name}
                                </Text>
                              </HStack>
                            </Td>
                            <Td>
                              {" "}
                              <Text textAlign={"center"}>{each.score}</Text>
                            </Td>
                            <Td>
                              {" "}
                              <Text textAlign={"center"}>
                                {each.total_score}
                              </Text>
                            </Td>
                            <Td>
                              {" "}
                              <Text
                                textAlign={"center"}
                                fontWeight={"bold"}
                                color={`${
                                  passMark && each?.percent < passMark
                                    ? "red"
                                    : "green"
                                }`}
                              >
                                {each?.percent}
                              </Text>
                            </Td>
                          </Tr>
                        ))}
                      {isEmpty && (
                        <Tr>
                          <Td colSpan={5}>
                            <Text textAlign={"center"} fontWeight={"bold"}>
                              No trainees have answered this question yet
                            </Text>
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {!isScoreReport && (
              <Box>
                <Flex flexWrap="wrap" justifyContent="space-between">
                  {selectedUserAnswer &&
                    selectedUserAnswer.map((answer, index) => (
                      <Flex mt={"7px"} key={index} mb={"14px"} width={"100%"}>
                        <Box width={"100%"}>
                          <Box
                            fontSize="14px"
                            fontWeight="500"
                            color=" #616161"
                            width={"100%"}
                          >
                            {questions &&
                              questions
                                .filter((each) => each.id == answer.question_id)
                                .map((quest) => (
                                  <Box width={"100%"}>
                                    {quest.file_url && (
                                      <Box width="450px" height="160px">
                                        <Image
                                          width="450px"
                                          height="150px"
                                          src={quest.file_url}
                                        />
                                      </Box>
                                    )}
                                    <Text fontWeight={"600"} mt={"10px"}>
                                      {index + 1}. {quest.question}
                                    </Text>
                                  </Box>
                                ))}
                          </Box>
                          <Flex alignItems={"center"}>
                            <Box width={"80%"}>
                              <Text
                                mt={"10px"}
                                fontSize="14px"
                                fontWeight="600"
                                color=" #616161"
                              >
                                Answer:{" "}
                              </Text>
                              <Text
                                mt={"5px"}
                                fontSize="14px"
                                fontWeight="500"
                                color=" #616161"
                              >
                                {" "}
                                {answer.answer}
                              </Text>
                            </Box>
                            <FormControl width={"5rem"}>
                              <FormLabel fontWeight={"600"} fontSize={"12px"}>
                                Enter Score:
                              </FormLabel>
                              <NumberInput
                                fontSize={12}
                                size="md"
                                name="score"
                                value={answer.score}
                                minWidth={"2rem"}
                                min={0}
                                max={2}
                                allowMouseWheel={true}
                                onChange={(value) => {
                                  const parsedValue = parseFloat(value);
                                  if (parsedValue <= 2) {
                                    handleChangeScore(
                                      index,
                                      "score",
                                      value,
                                      "user_question_answer_id",
                                      answer.id
                                    );
                                  } else {
                                    handleChangeScore(
                                      index,
                                      "score",
                                      "2",
                                      "user_question_answer_id",
                                      answer.id
                                    );
                                    toast({
                                      title: "Invalid Score",
                                      description:
                                        "Score cannot be greater than 2",
                                      status: "warning",
                                    });
                                  }
                                }}
                              >
                                <NumberInputField />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                            </FormControl>
                          </Flex>
                        </Box>
                      </Flex>
                    ))}
                </Flex>
                <Flex mt={"20px"} justifyContent={"flex-end"}>
                  <Button
                    size={"sm"}
                    onClick={() => {
                      submitAnswer();
                    }}
                    colorScheme="red"
                  >
                    Score trainee
                  </Button>
                </Flex>
              </Box>
            )}
          </Box>
        </Flex>
      )}
    </>
  );
}
